import SortActionTypes from './sort-types';

export const updateProjectSortSelection = (projectSortSelection) => ({
    type: SortActionTypes.UPDATE_PROJECT_SORT_SELECTION,
    payload: projectSortSelection
})

export const updateProjectSortOrder = (projectSortOrder) => ({
    type: SortActionTypes.UPDATE_PROJECT_SORT_ORDER,
    payload: projectSortOrder
})

export const clearProjectSort = () => ({
    type: SortActionTypes.CLEAR_PROJECT_SORT
})

export const updateTaskSortSelection = (taskSortSelection) => ({
    type: SortActionTypes.UPDATE_TASK_SORT_SELECTION,
    payload: taskSortSelection
})

export const updateTaskSortOrder = (taskSortOrder) => ({
    type: SortActionTypes.UPDATE_TASK_SORT_ORDER,
    payload: taskSortOrder
})

export const clearTaskSort = () => ({
    type: SortActionTypes.CLEAR_TASK_SORT
})

export const clearAllSorts = () => ({
    type: SortActionTypes.CLEAR_ALL_SORTS
})

export const clearAllGroupBys = () => ({
    type: SortActionTypes.CLEAR_ALL_GROUP_BYS
})